import { Button, SvgIcon } from '@mui/material';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import React from 'react';
import { useNavigate } from 'react-router';

function BackButton() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <Button
      onClick={goBack}
      sx={{ minWidth: 0, minHeight: 0, p: '6px 7px' }}
      color="secondary"
      variant="outlined"
    >
      <SvgIcon sx={{ fontSize: 24, color: 'primary.dark' }}>
        <ArrowLeftIcon />
      </SvgIcon>
    </Button>
  );
}

export default BackButton;
